<script lang="ts">
	import { onMount } from 'svelte';
	import type { IDropdownSelectorValue } from 'customTypes/dropdownSelector';
	import ArrowUp from 'assets/svg/arrowUp.svg?component';
	import ArrowDown from 'assets/svg/arrowDown.svg?component';
	import activeCurrency from 'stores/activeCurrency';
	import { getCurrencyPrice } from 'services/coin-data/currency-price';

	export let isMobileMenu = false;
	export let values: IDropdownSelectorValue[] = [];
	let isOpen = false;
	let selectRef;
	let selectedCurrency = findCurrency($activeCurrency.currency) || values[0];
	function findCurrency(currency: string) {
		return values.find((item) => item.value === currency);
	}

	const setCurrencyPrice = async (currency: string) => {
		const selectedCurrencyRate = await getSelectedCurrencyRate(currency);
		if (currency === 'usd') {
			activeCurrency.set({
				currency: 'usd',
				price: selectedCurrencyRate,
			});
		} else {
			activeCurrency.set({
				currency: currency,
				price: selectedCurrencyRate,
			});
		}
	};
	async function getSelectedCurrencyRate(currency: string) {
		if (currency === 'usd') {
			return 1;
		} else {
			return await getCurrencyPrice(selectedCurrency.id);
		}
	}
	onMount(() => {
		setCurrencyPrice(selectedCurrency.value);
		document.addEventListener('click', handleClose);
		return () => {
			document.removeEventListener('click', handleClose);
		};
	});

	const handleClose = (e: Event) => {
		if (selectRef && !selectRef.contains(e.target)) {
			isOpen = false;
		}
	};
</script>

<div class="wrapper">
	<!-- svelte-ignore a11y-click-events-have-key-events -->
	<!-- svelte-ignore a11y-no-static-element-interactions -->
	<div
		bind:this={selectRef}
		class="scale-wrapper"
		on:click={() => {
			isOpen = !isOpen;
		}}
	>
		<div class="selected-scale aligned">
			<img
				src={selectedCurrency.icon}
				alt={`${selectedCurrency.title}${isMobileMenu ? ' on mobile' : ''}`}
				class="dropdown-icon"
				width="16px"
				height="16px"
			/>
			<div class="item-description">
				{selectedCurrency.title ? selectedCurrency.title : ''}
			</div>
		</div>
		{#if isOpen}
			<ArrowUp class="select-icon" width={8} height={8} />
		{:else}
			<ArrowDown class="select-icon" width={8} height={8} />
		{/if}
	</div>
	<ul class="variants" class:visible={isOpen}>
		{#each values as option}
			<!-- svelte-ignore a11y-click-events-have-key-events -->
			<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
			<li
				class="item aligned"
				on:click|stopPropagation={async () => {
					selectedCurrency = findCurrency(option.value);
					await setCurrencyPrice(selectedCurrency.value);
					isOpen = !isOpen;
				}}
			>
				<img
					src={option.icon}
					alt={`${option.title} dropdown${isMobileMenu ? ' on mobile' : ''}`}
					class="dropdown-icon"
					loading="lazy"
				/>
				<div class="item-description">{option.title}</div>
			</li>
		{/each}
	</ul>
</div>

<style lang="scss">
	@import 'DropdownSelector';
</style>
